import React from 'react'
import { Box } from '@usap/uicomponents'
import { Heading3 } from './heading'
import {
  BreadcrumbBox, BreadcrumbBoxActive, startBorderRadius, lastBorderRadius,
} from './style/BreadcrumbTab.css'

export default function BreadcrumbTab({
  data,
  bgColor,
  bgActiveColor,
  activeStep,
}) {
  const lastIndex = data.length - 1
  const checkBorderToUse = index => {
    if (index === 0) {
      return startBorderRadius;
    }
    if (index === lastIndex) {
      return lastBorderRadius;
    }
    return { position: "relative" };
  };
  const checkFontColorToUse = index => {
    if (index === activeStep) {
      return "#FFF";
    }
    return "#d5d5d5";
  };
  const checkBoxToUse = (index, text) => {
    if (index === lastIndex) {
      return (
        <Box
          align="center"
          key={index}
          pad="xsmall"
          width="large"
          style={checkBorderToUse(index)}
          background={index === activeStep ? bgActiveColor : bgColor}
        >
          <Heading3
            style={{ fontSize: 14, color: checkFontColorToUse(index) }}
            title={text}
          />
        </Box>
      );
    }
    let arrowDesign = <BreadcrumbBoxActive />;
    if (index !== activeStep) {
      arrowDesign = <BreadcrumbBox />;
    }
    return (
      <Box
        align="center"
        key={index}
        pad="xsmall"
        width="large"
        style={checkBorderToUse(index)}
        background={index === activeStep ? bgActiveColor : bgColor}
      >
        <Heading3
          style={{
            fontSize: 14,
            color: checkFontColorToUse(index),
            display: "block",
            zIndex: 2
          }}
          title={text}
        />
        {arrowDesign}
      </Box>
    );
  };
  return (
    <Box
      id="breadcrumbTab"
      alignContent="center"
      overflow="hidden"
      width="1000px"
      direction="row"
      margin={{ bottom: '16px' }}
    >
      {data.map((result, index) => checkBoxToUse(index, result))}
    </Box>
  );
}
